import hooks from './address-details.hooks';
import createSchema from './address-details.schema';

export default (app) => {
  const service = app.service('api/address-details');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
